<template>
  <article class="c-object-puff">
    <div class="c-object-puff__media">
      <img
        v-if="projectImage && projectImage.src"
        :src="projectImage.src"
        :alt="projectImage.alt || projectTitle"
        loading="lazy"
      />
    </div>
    <div class="c-object-puff__content">
      <h3 class="c-object-puff__title">{{ projectTitle }}</h3>
      <div class="c-object-puff__text" v-if="projectDescription">
        {{ projectDescription }}
      </div>
      <a
        v-if="projectCtaLink && projectCtaText"
        :href="projectCtaLink"
        class="c-object-puff__button"
      >
        {{ projectCtaText }}
        <i aria-hidden="true" class="fa-regular fa-arrow-right"></i>
      </a>
    </div>
  </article>
</template>

<script>
export default {
  name: "VObjectPuff",
  props: {
    projectImage: {
      type: Object,
      default: null,
    },
    projectTitle: {
      type: String,
      default: "",
    },
    projectDescription: {
      type: String,
      default: "",
    },
    projectCtaLink: {
      type: String,
      default: "/",
    },
    projectCtaText: {
      type: String,
      default: "",
    },
  },
};
</script>

<style>
@import "./c-object-puff.css";
</style>
